import React from 'react';
import { StyleSheet } from 'react-native';

import { View } from '../uiold/View';

type Props = {
  children: React.ReactElement;
};

export function LegacyContentContainer({ children }: Props) {
  return (
    <View style={styles.container} className="content-container">
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
